export function maskNumistrailId(value) {
  if (!value) return value;
  const raw = String(value);
  const length = raw.length;
  if (length <= 2) return "***";
  if (length <= 4) return `${raw[0]}***`;
  if (length === 5) return `${raw[0]}***${raw[length - 1]}`;
  return `${raw[0]}***${raw.slice(-4)}`;
}
